import { api } from '@api'
import { Material, SapItemSupplier, GroupMaterial } from '@types'

interface GetMaterialsResponse {
  materials: Material[]
}

interface getGroupsMaterial {
  groups: GroupMaterial[]
}
interface GetPurchaseOrdersResponse {
  purchaseOrders: SapItemSupplier[]
}

const getMaterials = async (documentNumberId: string | undefined, validAt?: string) => {
  const response = await api.get<GetMaterialsResponse>('/materials', {
    params: { documentNumberId, validAt },
  })

  return response.data.materials
}

const getMaterialsBySupplier = async (supplierCode: number | undefined) => {
  if (supplierCode) {
    const response = await api.get<GetMaterialsResponse>(`/materials/supplier/${supplierCode}`)
    return response.data.materials
  }
  return []
}

const getPurchaseOrdersByMaterial = async (
  supplierCode: number | undefined,
  plantId?: string | undefined,
  validAt?: string,
) => {
  if (supplierCode) {
    const response = await api.get<GetPurchaseOrdersResponse>('/materials/purchase-orders', {
      params: { plantId, supplierCode, validAt },
    })
    return response.data.purchaseOrders
  }
  return []
}

const getByGroupsMaterial = async () => {
  const response = await api.get<getGroupsMaterial>('/materials/groups')

  return response.data.groups
}

export const MaterialsApi = {
  getMaterials,
  getMaterialsBySupplier,
  getPurchaseOrdersByMaterial,
  getByGroupsMaterial,
}
